require('./brokerStocksAdvancedBuySuccess.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');

// @commons
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const AdvancedBuySellStockSummary = require('components/broker/commons/advancedBuySellStockSummary/advancedBuySellStockSummary');
const { OKMessage } = require('commonsComponents/OKMessage');

// @ helpers
const { formatText } = require('core/i18n').i18n;

// @constants
const { BROKER_STOCKS_BUY_SELL_SUMMARY_BUY_MODIFIER, MYPROFILE_BROKER_ORDERSANDMOVEMENTS_URL } = require('constants/index');

const BrokerStocksAdvancedBuySuccess = props => {
    const { immProductFile, immBrokerStocksAdvancedBuy, immStocksContract, immSearchState } = props;
    const successMessage = formatText('broker-stocksAdvancedBuySuccessStepMessage');
    const mainButtonLabel = formatText('broker-stocksAdvancedBuySuccessStepBackToWalletButtonLabel');
    const secondaryButtonLabel = formatText('stocksContract-reviewOrders');
    const emailMessage = formatText('broker-stocksAdvancedBuySuccessStepEmailMessage');

    return (
        <WizardSuccess
            successMessage={successMessage}
            customClassName="stocks-advanced-buy-success"
            mainButton={{label: mainButtonLabel, url:'/myprofile/broker'}}
            secondaryButton={{
                    label: secondaryButtonLabel,
                    url: MYPROFILE_BROKER_ORDERSANDMOVEMENTS_URL
                }}
        >
            <div>
                <AdvancedBuySellStockSummary
                    immProductFile={immProductFile}
                    immBrokerStocksAdvancedState={immBrokerStocksAdvancedBuy}
                    immStocksContract={immStocksContract}
                    immSearchState={immSearchState}
                    modifier={BROKER_STOCKS_BUY_SELL_SUMMARY_BUY_MODIFIER}
                />
                <OKMessage type="informative">
                    {emailMessage}
                </OKMessage>
            </div>
        </WizardSuccess>
    );
};

BrokerStocksAdvancedBuySuccess.propTypes = {
    immProductFile: PropTypes.object.isRequired,
    immBrokerStocksAdvancedBuy: PropTypes.object.isRequired,
    immStocksContract: PropTypes.object.isRequired,
    immSearchState: PropTypes.object.isRequired
};

module.exports = BrokerStocksAdvancedBuySuccess;